export default __webpack_public_path__ + "static/media/pepsico-logo.2bef8003.png";